import React from "react";
import gitimg from '../assets/github.png';
import lkdn from '../assets/linkedin.png';
import mail from '../assets/mail.png';
import '../Styles/Contact.css'; // Import the CSS file

const ContactMe = () => {
  return (
    <div className="contactme">
      <div className="heading">
        <h1>CONTACT ME</h1>
      </div>
      <div className="contact-items">
        <div className="card">
          <a href="https://github.com/mdnadeem7" target="_blank" rel="noopener noreferrer">
            <img src={gitimg} alt="GitHub" />
            <span>mdnadeem7</span>
          </a>
        </div>
        <div className="card">
          <a href="mailto:mdnadeem4614@gmail.com">
            <img src={mail} alt="Email" />
            <span>mdnadeem4614@gmail.com</span>
          </a>
        </div>
        <div className="card">
          <a href="https://www.linkedin.com/in/md-nadeemuddin/" target="_blank" rel="noopener noreferrer">
            <img src={lkdn} alt="LinkedIn" />
            <span>md-nadeemuddin</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactMe;
